// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1s95Q","modalFooterButton":"ModalNotes_modalFooterButton__87yVu"};